import { init, mountWidget, observeDynamicWidgets } from "./widget";

export { init, mountWidget, observeDynamicWidgets };

const api = { init, mountWidget, observeDynamicWidgets };

if (typeof window !== "undefined") {
  window.LovesMusicEventsWidget = api;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(), { once: true });
  } else {
    init();
  }

  if (typeof document !== "undefined") {
    observeDynamicWidgets(document.documentElement);
  }
}

declare global {
  interface Window {
    LovesMusicEventsWidget: typeof api;
  }
}
